export default "__VITE_ASSET__0ff5b9b7__"